import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import type { RootState, AppDispatch } from '@/app/store';
import { APPLICATION_ROLES } from '@/features/auth/store/availableRolesSlice';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
/** Returns the typed Redux dispatch function used by the application. */
export const useAppDispatch = () => useDispatch<AppDispatch>();
/** Returns the typed Redux selector hook bound to the application state. */
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// Convenience hooks for common state selections
/** Selects authentication state from the Redux store. */
export const useAuth = () => useAppSelector((state) => state.auth);

// // Hook for checking authentication status
// export const useIsAuthenticated = () => useAppSelector((state) => state.auth.isAuthenticated);

// // Hook for getting current user
// export const useCurrentUser = () => useAppSelector((state) => state.user);

/** Returns role identifiers used when building role-aware requests and views. */
export const useRoleIds = () => {
  return {
    superAdminId: APPLICATION_ROLES['Super Admin'].id,
    masterId: APPLICATION_ROLES['Master'].id,
    userId: APPLICATION_ROLES['User'].id,
  };
};
